import { Box } from "@mui/material";
import Workers from "./workers";
import OfficeWorkers from "./OfficeWorrkers";
import OnSiteWorkers from "./OnSiteWorkers";
import SubscribeSection from "../HomeScreen/SubscribeSection";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FeaturesDesign from "./FeaturesDesign";
const ViewAllIndustries=()=>{
      const location = useLocation();
      useEffect(() => {
        const hash = window.location.hash;
      
        if (hash) {
          // Give time for DOM/rendering/layout/styles to finish
          setTimeout(() => {
            const id = hash.replace("#", "");
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }, 300); // Adjust timeout if needed
        }
      }, []);
  //       useEffect(() => {
  //   if (location.hash) {
  //     const id = location.hash.replace("#", "");
  //     const section = document.getElementById(id);
  //     if (section) {
  //       setTimeout(() => {
  //         section.scrollIntoView({ behavior: "smooth" });
  //       }, 100); // slight delay if component is still rendering
  //     }
  //   }
  // }, [location]);
    return(
        <>
        <Box>
        <Box sx={{backgroundColor:"#EFF4F8",
    scrollMarginTop: "30px", }} id='workers'
        >
<Workers/>
   </Box>
<Box id='office-workers' sx={{ scrollMarginTop: "50px", }}>
<OfficeWorkers/>
</Box>
      <Box sx={{backgroundColor:"#EFF4F8", scrollMarginTop: "50px", }} id='onsite-workers'>
<OnSiteWorkers/>
</Box>
      <Box  sx={{mb:10,}}>
<FeaturesDesign/>
</Box>
     {/* <Box sx={{backgroundColor:"#EFF4F8"}}>
<SubscribeSection/>
</Box> */}
</Box>
     
        </>
    )
}
export default ViewAllIndustries